"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoadMoreMessagesHeader = void 0;
const react_1 = __importStar(require("react"));
const react_native_1 = require("react-native");
const LanguageProvider_1 = require("../../i18n/LanguageProvider");
const TextResources_1 = require("../../i18n/TextResources");
const theme_1 = require("../../theme");
const store_1 = require("../store");
const LoadMoreMessagesHeader = ({ loadMessages }) => {
    const theme = theme_1.useSharedTheme();
    const meta = store_1.useMessagesMeta();
    const isLoading = store_1.useMessagesAreLoading();
    const translateContext = react_1.useContext(LanguageProvider_1.LanguageContext);
    const onPress = react_1.useCallback(() => {
        if (!meta)
            return;
        loadMessages((meta === null || meta === void 0 ? void 0 : meta.currentPage) + 1);
    }, [meta, loadMessages]);
    if (isLoading || !meta || meta.lastPage)
        return null;
    return (react_1.default.createElement(react_native_1.TouchableOpacity, { style: { alignItems: 'center' }, onPress: onPress },
        react_1.default.createElement(react_native_1.View, { style: {
                backgroundColor: theme.colors.primary,
                borderRadius: 4,
                margin: 8,
                padding: 8,
            } },
            react_1.default.createElement(react_native_1.Text, { style: { color: theme.colors.textLight } }, TextResources_1.getTextResource(translateContext.currentLanguage).mailbox
                .loadMoreMessages))));
};
exports.LoadMoreMessagesHeader = LoadMoreMessagesHeader;
